<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading d-flex justify-content-between align-items-center">
                <h1>Patents Expiration Dashboard</h1>
            </div>

            <!-- Filter Dropdown -->
            <div class="mb-3" style="display: flex; justify-content: space-between; align-items: center;">
                <p-dropdown [options]="filterOptions" [(ngModel)]="selectedFilter" placeholder="Select Filter"
                    (onChange)="onFilterChange()">
                </p-dropdown>

                <span class="p-input-icon-left">
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                </span>
            </div>

            <!-- Summary Info -->
            <div *ngIf="filterType" class="summary-box">
                <p><strong>Date Range:</strong> {{ dateRange }}</p>
                <p><strong>Total Records:</strong> {{ totalCount }}</p>
            </div>

            <!-- Data Table -->
            <p-table #dt [value]="patentsData" [paginator]="true" [rows]="10" [loading]="loading"
                [responsiveLayout]="'scroll'"
                [globalFilterFields]="['Brand Name', 'NDA Number', 'Patent Expiration', 'Patent No']">

                <ng-template pTemplate="header">
                    <tr>
                        <th>Brand Name</th>
                        <th>NDA Number</th>
                        <th>Patent No</th>
                        <th>Patent Expiration</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>{{ row['Brand Name'] }}</td>
                        <td>{{ row['NDA Number'] }}</td>
                        <td>{{ row['Patent No'] }}</td>
                        <td>{{ row['Patent Expiration'] }}</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" class="text-center">No data available</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </ng-container>
</div>